module.exports = __webpack_public_path__ + "static/media/OurProduct-PinkWaveMobile.88e06f6b.svg";